import { Link } from "react-router-dom";
import { User } from "lucide-react";
import { RatingBadge } from "../StarRating";
import { BadgeList } from "../UserBadges";

/**
 * Seller profile header shown in the Contact Card sidebar of AdDetailPage.
 *
 * Extracted from AdDetailPage.jsx (Feb 2026 refactor, iter 37).
 * Pure presentational — no local state, all data via props.
 */
export default function SellerHeader({ ad, sellerBadges = [] }) {
  const verified = sellerBadges.includes("verified") || ad?.is_verified;
  return (
    <div className="flex items-center gap-4 mb-5 pb-5 border-b border-white/10">
      <div className="relative shrink-0">
        {ad.user_picture ? (
          <img
            src={ad.user_picture}
            alt=""
            className={`w-14 h-14 rounded-full object-cover ring-2 ring-offset-2 ring-offset-[#0a0a0a] ${verified ? "ring-emerald-500/60" : "ring-white/10"}`}
          />
        ) : (
          <div className={`w-14 h-14 rounded-full bg-gradient-to-br from-blue-600/30 to-fuchsia-600/30 flex items-center justify-center ring-2 ring-offset-2 ring-offset-[#0a0a0a] ${verified ? "ring-emerald-500/60" : "ring-white/10"}`}>
            <User className="w-7 h-7 text-blue-400" />
          </div>
        )}
        {verified && (
          <span className="absolute -bottom-0.5 -right-0.5 w-5 h-5 rounded-full bg-emerald-500 border-2 border-[#0a0a0a] flex items-center justify-center shadow-lg shadow-emerald-500/40">
            <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <Link
            to={`/seller/${ad.user_id}`}
            className="text-white font-bold hover:text-blue-300 transition-colors truncate"
          >
            {ad.user_name || "Anonim"}
          </Link>
          {verified && (
            <span
              className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/15 border border-emerald-500/30 text-emerald-300 text-[10px] font-bold uppercase tracking-wider"
              data-testid="verified-badge"
            >
              Verificat
            </span>
          )}
        </div>
        <div className="flex items-center gap-2 mt-1">
          {ad.user_rating ? (
            <RatingBadge rating={ad.user_rating} totalReviews={ad.user_reviews} size="sm" />
          ) : (
            <span className="text-slate-500 text-xs">Vânzător</span>
          )}
        </div>
        {sellerBadges.length > 0 && (
          <div className="flex gap-1 mt-1.5">
            <BadgeList badges={sellerBadges} />
          </div>
        )}
      </div>
    </div>
  );
}
